import { render, staticRenderFns } from "./BillPayableDashboard.vue?vue&type=template&id=32dc91a4"
import script from "./BillPayableDashboard.vue?vue&type=script&lang=js"
export * from "./BillPayableDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports